import { useContributionsPageState } from '#src/app/pages/accountSettings/contributions/main/pageContext';

type InputSeverityType = 'critical' | 'success';
type OutputSeverityType = 'error' | 'success' | null;

const alertSeverityVariantMap: Record<InputSeverityType, OutputSeverityType> = {
	critical: 'error',
	success: 'success',
};

type Result = ModelHookResult<
	{
		message: string | null;
		severity: OutputSeverityType;
	},
	{
		resetPageMessage: () => void;
	}
>;

export function usePageBanner(): Result {
	const [{ pageMessage }, mutations] = useContributionsPageState();

	const message = pageMessage?.message || null;

	const severity = pageMessage?.severity ? alertSeverityVariantMap[pageMessage.severity] : null;

	return {
		data: { message, severity },
		actions: {
			resetPageMessage: mutations.resetPageMessage,
		},
	};
}
